// @mui
import { styled } from '@mui/material/styles';
import {
  Step,
  Stepper,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
} from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const STEPS = ['시간 설정', '인건비 설정', '미팅 설정'];

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#000',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#000',
    zIndex: 1,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));


function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Iconify icon="ic:outline-check" width={22} height={22} className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}


export default function InstantMatchingProfileStepper({ step, goto }) {
  const smUp = useResponsive('up', 'sm');

  const goStep = async (target) => {
    if (target < step) {
      goto(target);
    }
  }

  return (
    <Stepper sx={{ mx: 'auto', width: '100%', maxWidth: '100%' }} alternativeLabel activeStep={step} connector={<QontoConnector />}>
      {STEPS.map((label, index) => {
        return (
        <Step key={label} onClick={() => goStep(index)} sx={{ '&:hover': {
          ...(index < step) && ({
            cursor: 'pointer',
        })
        },}}>
          <StepLabel StepIconComponent={QontoStepIcon} />
        </Step>
      )}
      )}
    </Stepper>
  );
}
